import React, { useState } from "react";
import { Link } from "react-router-dom"
import { updateJobServiceOtherCosts } from "requesters/jobServiceRequester"
import { useSelector } from "react-redux";
import { format } from "date-fns"
import { getBaseUrl } from "../../reducers";

const TimeSpentTable = ({ data, reloadData }) => {
  const [editingJobServiceId, setEditingJobServiceId] = useState(null)
  const [tempOtherCosts, setTempOtherCosts] = useState("")

  const baseUrl = useSelector(getBaseUrl)

  const NoDataSection = () => (
    <div className="container-inner">
      <div className="text-center py-5">
        <h4>No Data Available</h4>
      </div>
    </div>
  )

  if (!data || data.length === 0) return NoDataSection();

  const onEditOtherCosts = (jobServiceId, currentValue) => {
    setEditingJobServiceId(jobServiceId)
    setTempOtherCosts(currentValue.replace(/[+$-]/g, ''))
  }

  const onSaveOtherCosts = async (jobServiceId) => {
    try {
      const payload = { other_costs: parseFloat(tempOtherCosts) || 0 }
      const response = await updateJobServiceOtherCosts(baseUrl, jobServiceId, payload)

      if (response.status === 200) {
        setEditingJobServiceId(null)
        setTempOtherCosts("")
        if (reloadData) {
          reloadData()
        }
      }
    } catch (error) {
      console.error("Error updating other costs:", error)
      alert("Failed to update other costs. Please try again.")
    }
  }

  const onCancelEditOtherCosts = () => {
    setEditingJobServiceId(null)
    setTempOtherCosts("")
  }

  const handleKeyPress = (e, jobServiceId) => {
    if (e.key === 'Enter') {
      onSaveOtherCosts(jobServiceId)
    } else if (e.key === 'Escape') {
      onCancelEditOtherCosts()
    }
  }

  const TimeSpentTableRow = rowData => {
    const {
      jobId,
      jobNo,
      jobTitle,
      completedDate,
      jobServiceId,
      jobServiceType,
      surveyorHours,
      draftingHours,
      registeredSurveyorHours,
      totalTimeSpentHours,
      quotedValue,
      otherDepartmentHours,
      otherDepartmentCost,
      otherCosts,
      totalCost,
      differenceCost,
      budgetPercentage,
      rawOtherCosts
    } = rowData

    const isEditingThisRow = editingJobServiceId === jobServiceId

    return (
      <tr key={jobNo + jobServiceId}>
        <td>
          <Link to={`/jobs/${jobId}/job_services/${jobServiceId}?tab=Time Spent`} target="_blank" className="link-no-decoration">{jobNo}</Link>
        </td>
        <td title={jobTitle}>
          <Link to={`/jobs/${jobId}/job_services/${jobServiceId}?tab=Time Spent`} target="_blank" className="link-no-decoration">{jobTitle}</Link>
        </td>
        <td>{format(new Date(completedDate), "d MMM yyyy")}</td>
        <td>{jobServiceType}</td>
        <td>{surveyorHours}</td>
        <td>{draftingHours}</td>
        <td>{registeredSurveyorHours}</td>
        <td>{otherDepartmentHours}</td>
        <td>{totalTimeSpentHours}</td>
        <td>
          $
          {quotedValue}
        </td>
        <td>
          $
          {otherDepartmentCost}
        </td>
        <td style={{ minWidth: "120px" }}>
          {isEditingThisRow ? (
            <div className="d-flex align-items-center">
              <span className="mr-1">$</span>
              <input
                type="number"
                step="0.01"
                value={tempOtherCosts}
                onChange={(e) => setTempOtherCosts(e.target.value)}
                onKeyDown={(e) => handleKeyPress(e, jobServiceId)}
                className="form-control form-control-sm"
                style={{ width: "70px" }}
                autoFocus />
              <button className="btn btn-sm btn-success ml-1" onClick={() => onSaveOtherCosts(jobServiceId)} title="Save">
                ✓
              </button>
              <button className="btn btn-sm btn-secondary ml-1" onClick={onCancelEditOtherCosts} title="Cancel">
                ✕
              </button>
            </div>
          ) : (
            <span className="cursor-pointer text-primary" onClick={() => onEditOtherCosts(jobServiceId, otherCosts)} title="Click to edit other costs">
              ${otherCosts}
            </span>
          )}
        </td>
        <td className="text-truncate" style={{ maxWidth: "150px" }} title={totalCost}>
          $
          {totalCost}
        </td>
        <td className={`text-truncate ${parseFloat(differenceCost) > 0 ? "bg-success" : "bg-danger-custom"} text-white`} style={{ maxWidth: "150px" }} title={differenceCost}>
          {differenceCost}
        </td>
        <td>
          <span className={`badge ${parseFloat(budgetPercentage) > 100 ? "badge-danger" : "badge-success"}`}>
            {budgetPercentage}
          </span>
        </td>
      </tr>
    )
  }

  return (
    <div className="container-inner">
      <div className="table-responsive">
        <table className="table table-striped table-hover">
          <thead className="thead-dark">
            <tr>
              <th scope="col">Job No</th>
              <th scope="col">Job Title</th>
              <th scope="col">Completed Date</th>
              <th scope="col">Job Service/Type</th>
              <th scope="col">Surveyor</th>
              <th scope="col">Drafting</th>
              <th scope="col">Registered Surveyor</th>
              <th scope="col">Other Hours</th>
              <th scope="col">Total Hours</th>
              <th scope="col">Quoted Value</th>
              <th scope="col">Other Department</th>
              <th scope="col">Other Costs</th>
              <th scope="col">Total Cost</th>
              <th scope="col">Difference</th>
              <th scope="col">Budget %</th>
            </tr>
          </thead>
          <tbody>
            {data.map(rowData => TimeSpentTableRow(rowData))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TimeSpentTable;